import deTranslations from '../../../assets/i18n/de.json';
import enTranslations from '../../../assets/i18n/en.json';
import huTranslations from '../../../assets/i18n/hu.json';
import nlTranslations from '../../../assets/i18n/nl.json';

export const defaultTranslations = {
  en: enTranslations,
  de: deTranslations,
  nl: nlTranslations,
  hu: huTranslations,
};
